const firebaseConfig = {
    apiKey: "AIzaSyAeCExDuOe4l0Z9vIcNsUzoz-SwSBPVmqs",
    authDomain: "yokohama-city-youchien-dev.firebaseapp.com",
    databaseURL: "https://yokohama-city-youchien-dev.firebaseio.com",
    projectId: "yokohama-city-youchien-dev",
    storageBucket: "yokohama-city-youchien-dev.appspot.com",
    messagingSenderId: "280874969270",
    appId: "1:280874969270:web:f86e93c19de11f42139e17"
};

export default firebaseConfig;